import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />

      <main className="flex-1 pt-16 md:pt-20 flex items-center">
        <div className="max-w-shell mx-auto w-full px-4 md:px-8 py-16 md:py-24">
          <div className="relative flex flex-col items-center text-center">
            <span className="font-label text-[64px] md:text-[120px] leading-none text-background-200 select-none">
              404
            </span>
            <h1 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-50">
              这个页面不在地图上
            </h1>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-500">
              你访问的地址可能已经调整或不存在。回到首页继续浏览，或者去影视分类页找找看。
            </p>
            <p className="mt-2 font-label text-[11px] text-foreground-700 break-all max-w-md">
              {location.pathname}
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/"
                className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-foreground-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-home-4-line"></i>
                返回首页
              </Link>
              <Link
                to="/category"
                className="h-11 px-6 inline-flex items-center justify-center gap-2 rounded-md border border-background-300 text-foreground-200 text-sm hover:border-accent-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-grid-line"></i>
                浏览影视分类
              </Link>
            </div>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}